export default __webpack_public_path__ + "static/media/andrej500transparent.b0318564.png";